import { Cloud, K8sProvider } from '@cast/shared-types';
import { CloudAssetIntegrationsScope } from '@cast/types-inventory';

import { useAssetDiscoveryCommandQuery } from 'hooks/queries/inventory';

import { ScriptSetupSlide } from './ScriptSetupSlide';
import { CommitmentProvider } from '../../../types';
import { useUploadCommitmentsContext } from '../UploadCommitmentsProvider';

type SetupSlideProps = {
  isMultiCloud: boolean;
  onNext: () => void;
  onBack: () => void;
  activeProvider: CommitmentProvider | undefined;
};

export const SetupSlide = ({
  isMultiCloud,
  onNext,
  onBack,
  activeProvider,
}: SetupSlideProps) => {
  const { autoEnable } = useUploadCommitmentsContext();
  const useQuery = (() => {
    switch (activeProvider) {
      case K8sProvider.AKS:
        return useAssetDiscoveryCommandQuery.bind(null, {
          provider: Cloud.azure,
          scope: CloudAssetIntegrationsScope.AZURE_COMMITMENTS,
          commitmentAutoAssignment: autoEnable,
        });
      case K8sProvider.GKE:
        return useAssetDiscoveryCommandQuery.bind(null, {
          provider: Cloud.gcp,
          scope: CloudAssetIntegrationsScope.GCP_COMMITMENTS,
          commitmentAutoAssignment: autoEnable,
        });
      case K8sProvider.EKS:
        return useAssetDiscoveryCommandQuery.bind(null, {
          provider: Cloud.aws,
          scope: CloudAssetIntegrationsScope.AWS_COMMITMENTS,
          commitmentAutoAssignment: autoEnable,
        });
    }
    return undefined;
  })();

  if (!useQuery) {
    return null;
  }

  return (
    <ScriptSetupSlide
      provider={activeProvider}
      isMultiCloud={isMultiCloud}
      onBack={onBack}
      onNext={onNext}
      useQuery={useQuery}
    />
  );
};
